import { render } from "./EditShowModal.vue?vue&type=template&id=24953c66"
import script from "./EditShowModal.vue?vue&type=script&lang=ts"
export * from "./EditShowModal.vue?vue&type=script&lang=ts"
script.render = render

export default script